import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { motion, useAnimation } from "framer-motion"
import { Theme } from 'theme'

import {
  Section,
  Title,
  Subtitle,
  BackgroundVideo,
  Row
} from './styled'

// components
import Buttons from 'components/Buttons'
import LandingVideoModal from 'components/ModalSystem/Modals/LandingVideo'
import ModalState from 'components/ModalSystem/ModalState'
import LightIcon from 'components/StaticIcons/Light'

// media
import ConfettiIcon from './assets/Confetti.webp'
import VideoMp4 from './assets/background.mp4'

export default function WelcomeScreen() {

  const { t, i18n } = useTranslation()

  const vidRef = useRef();
  useEffect(() => {
    vidRef.current.play();
  }, []);

  const control = useAnimation()

  useEffect(() => {
    control.start("end");
  }, [control]);

  const titleAnimation = { ...Theme.motion.default, delay: 0.3 }
  const btnAnimation = { ...Theme.motion.default, delay: 0.4 }
  const subtitleAnimation = { ...Theme.motion.default, delay: 0.5 }

  return (

    <Section>

      <Title
        variants={Theme.motion.jumpBottom} initial="start" animate={control} transition={titleAnimation}
      >
        {t("landing.description")}
      </Title>

      <motion.div
        className="btnAnimation"
        variants={Theme.motion.jumpBottom}
        initial="start"
        animate={control}
        transition={btnAnimation}
      >
        <Row>
          <Buttons onClick={() => document.querySelector('html').scrollTo(0, 999999)} variable="solid">{t("btns.findTeammates")}</Buttons>
          <Buttons variable="outline" leftIcon={<LightIcon />} onClick={() => ModalState.setComponent(<LandingVideoModal />)}>
            {t("btns.demo")}
          </Buttons>
        </Row>
      </motion.div>

      <Subtitle
        variants={Theme.motion.jumpBottom}
        initial="start"
        animate={control}
        transition={subtitleAnimation}
      >
        <img src={ConfettiIcon} alt='Confetti' loading='lazy' />
        {t("landing.giftBeforeRegister")}
      </Subtitle>

      <BackgroundVideo
        ref={vidRef}
        autoplay={true}
        loop
        preload
        src={VideoMp4}
        muted
        playsinline
        type="video/mp4"
      ></BackgroundVideo>

    </Section>

  )

}